import ApiClient from '../ApiClient';

class WgptContactCardsAPI extends ApiClient {
  constructor(contactId) {
    super(`contacts/${contactId}/cards`, { accountScoped: true, wgpt: true });
  }
}

export default WgptContactCardsAPI;
